package com.essntl.features.service.domain.model.service

sealed class ServiceOrderType(val orderName: String) {
    data object Alphabetical : ServiceOrderType("Alphabetical")

    data object LastCreated : ServiceOrderType("Last created")

    data object RecentlyChanged : ServiceOrderType("Recently changed")

    companion object {
        val Default = LastCreated
    }
}
